// plugins/magnific-popup.client.ts
import { defineNuxtPlugin } from '#app';
import $ from 'jquery';
import 'magnific-popup';

export default defineNuxtPlugin((nuxtApp) => {
  // Ensure jQuery is available globally
  (window as any).jQuery = $;
  (window as any).$ = $;

  // Initialize Magnific Popup
  $(document).ready(function() {
    // Basic Modal
    $('.modal-basic').magnificPopup({
      type: 'inline',
      preloader: false,
      modal: true
    });

    // Sizes Modal
    $('.modal-sizes').magnificPopup({
      type: 'inline',
      preloader: false,
      modal: true
    });

    // Modal with CSS animation
    $('.modal-with-zoom-anim').magnificPopup({
      type: 'inline',
      fixedContentPos: false,
      fixedBgPos: true,
      overflowY: 'auto',
      closeBtnInside: true,
      preloader: false,
      midClick: true,
      removalDelay: 300,
      mainClass: 'my-mfp-zoom-in',
      modal: true
    });

    // Modal with move animation
    $('.modal-with-move-anim').magnificPopup({
      type: 'inline',
      fixedContentPos: false,
      fixedBgPos: true,
      overflowY: 'auto',
      closeBtnInside: true,
      preloader: false,
      midClick: true,
      removalDelay: 300,
      mainClass: 'my-mfp-slide-bottom',
      modal: true
    });

    // Modal Dismiss
    $(document).on('click', '.modal-dismiss', function (e) {
      e.preventDefault();
      $.magnificPopup.close();
    });

    // Modal Confirm
    $(document).on('click', '.modal-confirm', function (e) {
      e.preventDefault();
      $.magnificPopup.close();
      new PNotify({
        title: 'Success!',
        text: 'Modal Confirm Message.',
        type: 'success'
      });
    });

    // Form Modal
    $('.modal-with-form').magnificPopup({
      type: 'inline',
      preloader: false,
      focus: '#name',
      modal: true,
      callbacks: {
        beforeOpen: function() {
          if ($(window).width() < 700) {
            this.st.focus = false;
          } else {
            this.st.focus = '#name';
          }
        }
      }
    });

    // Ajax Modal
    $('.simple-ajax-modal').magnificPopup({
      type: 'ajax',
      modal: true
    });
  });
});
